import React, {useEffect, useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {ReactComponent as FilterIcon} from '../assets/icons/icon-filter.svg';
import {H4} from '../components/H4';
import {H6} from '../components/H6';
import {Icon} from '../components/Icon';
import {Section} from '../components/Section';
import {getProductList} from "../apis/products";
import {ProductQuery} from "../types/types";
import {ProductCard} from '../components/ProductCard';
import {Button} from "../components/Button";
import {nToast} from "../plugins/reactToast";
import injectSizesIntoProductList from "../utils/injectSizesIntoProductList";
import {useUserDispatch, useUserState} from "../context/UserContext";
import { Bridge } from '../plugins/bridge';
import { AIRBRIDGE_EVENT } from '../constants/airbridge';

type SearchResultProps = {
    count: number
    keyword: string
}

const MobileSearch = (props: SearchResultProps) => (
    <div className="md:hidden">
        <p className="text-13 text-center">
            '{props.keyword}' 에 대한 {props.count} 개의 상품이 조회되었습니다.
        </p>
        {/* <div className="flex justify-between pt-4">
            {props.count > 0 ? (
                <>
                    <div className="bg-brand-2 flex space-x-2 rounded-full items-center px-2 mr-4">
                        <p className="text-12">Reset</p>
                        <div className="">
                            <Icon.XRound/>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="flex space-x-2 items-center pr-4 ">
                        <p className="">Refine</p>
                        <button className="bg-brand-2 rounded-full wh-7 grid place-content-center">
                            <FilterIcon/>
                        </button>
                    </div>
                </>
            )}
        </div> */}
    </div>
);
const DesktopSearch = (props: SearchResultProps) => (
    <div className='hidden md:block'>
        {/* <H6 className="">검색 결과</H6> */}
        {/* {props.count > 0 ? (
            <> */}
                    <H6>'{props.keyword}' 에 대한 {props.count} 개의 상품이 조회되었습니다. </H6>
            {/* </>
        ) : (
            <>
                <H6>We couldn't find anything for "{props.keyword}"</H6>
            </>
        )} */}
    </div>
);

export const SearchResultsPage = () => {
    const {push, location} = useHistory();
    const {keyword} = useParams<{ keyword: string }>()
    const decoded = decodeURIComponent(keyword);
    const [count, setCount] = useState<number>(0)
    const [page, setPage] = useState<number>(0)
    const [finalPage, setFinalPage] = useState<number>(0)
    const {products, lastQuery} = useUserState();
    const dispatch = useUserDispatch();

    useEffect(() => {
        Bridge.sendAmplitude('search_completed', {search_keyword : keyword});
        Bridge.sendAirbridge(AIRBRIDGE_EVENT.searchResults, {
            semanticAttributes: {
                query: keyword
            }
        })
    }, []);

    useEffect(() => {
        dispatch({type: 'SET_PRODUCTS', payload: []});
        setCount(0);
        setPage(0);
        dispatch({type: 'SET_LAST_QUERY', payload: location.pathname + location.search});
        getProductList({searchKeyword: decoded, page: page, size: 12, sort: 'currentPrice,desc'}).then(r => {
            setFinalPage(r.data.payload.totalPages);
            dispatch({type: 'SET_PRODUCTS', payload: r.data.payload.content});
            injectSizesIntoProductList(r.data.payload.content).then((productList: ProductQuery[]) => {
                    dispatch({type: 'SET_PRODUCTS', payload: productList});
              }).catch(e => console.log(e));
            setCount(r.data.payload.totalElements);
        }).catch(e => console.log(e))
    }, [decoded])

    useEffect(() => {
        if (finalPage !== 0 && page >= finalPage) {
            nToast('마지막 페이지 입니다');
        } else {
            page !== 0 && getProductList({searchKeyword: decoded, page: page, size: 12}).then(r => {
                setFinalPage(r.data.payload.totalPages);
                dispatch({type: 'SET_PRODUCTS', payload: [...products, ...r.data.payload.content]});
                injectSizesIntoProductList(r.data.payload.content).then((productList: ProductQuery[]) => {
                    dispatch({type: 'SET_PRODUCTS', payload: [...products, ...productList]});
                }).catch(e => console.log(e));
                setCount(r.data.payload.totalElements);
            }).catch(e => console.log(e))
        }
    }, [page])

    return (
        <>
            <div
                className="border-b p-4 -mx-4 mb-4">
                <MobileSearch count={count} keyword={decoded}/>
                <DesktopSearch count={count} keyword={decoded}/>
            </div>

            {products.length > 0 ? (
                <>
                    <div className="md:px-4 grid grid-cols-2 md:grid-cols-4 md:gap-x-3 gap-x-2 gap-y-10 md:-mx-4 -mx-2">
                        {products.map((product, index) => (
                            <ProductCard key={index}
                                         product={product}
                                         onClick={() => push(`/product/${product.productId}`)}
                            />
                        ))}
                    </div>
                    <div className="flex justify-center mt-10">
                        <Button
                            text="더보기"
                            onClick={() => setPage(page + 1)}
                            className="filled-brand-2 text-black px-12 mb-20"
                        />
                    </div>
                </>
            ) : (
                <>
                    <h4 data-aos="fade-in" data-aos-delay="900"><H4 className="font-bold">검색된 상품이 없습니다.</H4></h4>
                </>
            )}
        </>
    );
};
